import React, { Component } from 'react';
import { useContext, useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import Cookies from 'universal-cookie';

import Adminheader from './Adminheader';
import Adminsidebar from './Adminsidebar';
import Editsettingmodal from "./Editcmsmodal";
import Addsettingmodal from "./Addsettingmodal";


import Web3 from "web3";
import '../../css/styles.css';

import coin from "../../images/coin.png"
import favicon from "../../images/chainpad/logo.png"

import loader from "../../images/loader.gif"
import { Dropdown, Nav, Tab, Row, Col, Container, ProgressBar, InputGroup, Form } from 'react-bootstrap';
import {GetPoolListInfo} from '../../hooks/uselockedstack'

import { getsettinghook ,getcmshook} from '../../hooks/usebackend';


import Editaprmodal from './Editaprmodal';

const cookies = new Cookies();
class Adminaprfee extends Component {

    showLoader() {
        document.getElementsByTagName("body")[0].classList.add("overflow_hidden");
        document.getElementById("logo_overlay").style.opacity = 0.5;
        document.getElementById("loader_div").classList.remove("d-none");
        document.getElementById("loader_div").classList.add("d-block");


    }

    hideLoader() {
        document.getElementsByTagName("body")[0].classList.remove("overflow_hidden");
        document.getElementById("logo_overlay").style.opacity = 1;
        document.getElementById("loader_div").classList.remove("d-block");
        document.getElementById("loader_div").classList.add("d-none");



    }

    componentDidMount() {
        this.restrict()
        // this.showLoader();
        this.hideLoader();

        this.getcms()
        this.getpoolinfodata()
        console.log("cms", this.state.cms.length, this.state.cms && this.state.cms.length > 0)

    }

    onImageChange = event => {
        if (event.target.files && event.target.files[0]) {
            let img = event.target.files[0];
            this.setState({
                image: URL.createObjectURL(img)
            });
        }
    };


    restrict = async () => {
        var email = cookies.get('cryp-launch-admin-email');
        console.log("email", email);
        if (!email) {
            this.props.history.push("/login")
        }
    }

    getcms = async () => {
      
        let cmscontent = await getcmshook();
        console.log("cmscontent", cmscontent);
        if (cmscontent?.data?.success == true) {
            this.setState({ "cms": cmscontent?.data?.data });
        }
        // let count = Math.ceil(setting?.data?.count / this.state.limit)
        // this.setState({ "pagecount": count });
        // if(count < 5){
        //   this.setState({"stepcount" : count})
        // }
    }
    getpoolinfodata = async () => {
      
        let poolcontent = await GetPoolListInfo();
        console.log("poolcontent_poolcontent", poolcontent);
         if (poolcontent) {
            this.setState({ "poolinfo": poolcontent });  
               }
                     // }
        // let count = Math.ceil(setting?.data?.count / this.state.limit)
        // this.setState({ "pagecount": count });
        // if(count < 5){
        //   this.setState({"stepcount" : count})
        // }
    }

    // handlenextpage = async () => {
    //     let payload = {
    //         limit: this.state.limit,
    //         skip: this.state.skip + this.state.limit
    //     }
    //     let result = await getsettinghook(payload);
    //     if (result?.data?.success == true) {
    //         this.setState({ "settings": result?.data?.data });
    //     }
    //     if (this.state.currentpage % 5 == 0) {
    //         this.setState({ "button": this.state.button + 5 })
    //         // if(this.state.pagecount )
    //     }
    //     this.setState({ "skip": this.state.skip + this.state.limit })
    //     this.setState({ "currentpage": this.state.currentpage + 1 })
    // }

    // handleprevpage = async () => {
    //     let payload = {
    //         limit: this.state.limit,
    //         skip: this.state.skip - this.state.limit
    //     }
    //     let result = await getsettinghook(payload);
    //     if (result?.data?.success == true) {
    //         this.setState({ "settings": result?.data?.data });
    //     }
    //     if ((this.state.currentpage - 1) % 5 == 0) {
    //         this.setState({ "button": this.state.button - 5 })
    //         // if(this.state.pagecount )
    //     }
    //     this.setState({ "skip": this.state.skip - this.state.limit });
    //     this.setState({ "currentpage": this.state.currentpage - 1 });
    // }

    // handlenumpage = async (val) => {
    //     this.setState({ "currentpage": parseInt(val) })
    //     let payload = {
    //         limit: this.state.limit,
    //         skip: (parseInt(val) * 10) - 10
    //     }

    //     let result = await getsettinghook(payload);
    //     if (result?.data?.success == true) {
    //         this.setState({ "settings": result?.data?.data });
    //     }
    //     this.setState({ "skip": (parseInt(val) * 10) - 10 })

    // }

    constructor(props) {
        super(props);
        this.state = {
            editaprModal: false,
            addsettingModal: false,
            settings: [],
            cms: [],
            poolinfo:[],
            singlesetting: {},
            pid:{},
            image: null,
            skip: 0,
            limit: 10,
            pagecount: 0,
            button: 0,
            currentpage: 1,

            stepcount: 5
        };
    }

    onDismiss() {
        this.setState({ editaprModal: false });
    }

    onDismissAdd() {
        this.setState({ addsettingModal: false });
    }





    render() {


     const  getdays = (data) => {
              console.log("data_data",data);
              const day = data;
              const days = day / (86400*30);

              return days
        }
        const location = this.props.location.pathname.split('/')[1];

        const { editaprModal, addsettingModal } = this.state

        return (
            <div id="loader_main">
                <div id="loader_div">
                    <span className="spin_round">

                    </span>
                    <img src={favicon} className="logo_load" />
                </div>
                <div className='logo_overlay' id="logo_overlay">


                    <Adminheader />

                    <div className="whole_sec pb-5">
                        <div className='flex_side_right adminisideright'>
                            <Adminsidebar />
                            {/* ongoing_sec */}
                            <div className='right_side_sec adminside'>

                                <div className="right_side_spacing">
                                    <div className='ongoing_sec proj_bg pb-5'>
                                        <div className="container px-1">
                                            <div className='top_heqad_sec mt-5 mt-md-0'>

                                                <div className="row">
                                                    <div className="col-12 col-md-6 flex_cen_col mt-md-5 mb-md-4">
                                                        <p className="banner_subtitle form_subhead">APR List</p>

                                                        {/* <hr className='hr_yellow mt-5'/> */}
                                                    </div>
                                                    <div className="col-12 col-md-6 flex_cen_col mt-md-5 mb-md-4">
                                                        <div className='text-right'>
                                                            {/* <button className="get-started-btn btn_width_auto" onClick={() => this.setState({ addsettingModal: true })}>Add</button> */}
                                                        </div>
                                                    </div>

                                                </div>


                                                <div className="inner_bg">
                                                    <div className="container px-1">
                                                        {/* <div class="table-responsive">
                                                            <table className="table recepients_table">
                                                                <thead>
                                                                    <tr>
                                                                        <th>CMS Name</th>
                                                                        <th>Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tr>
                                                                    <td>Banner Image</td>
                                                                    <td className="d-flex justify-content-start"><a className="link_text" onClick={() => {
    
                                                                        this.setState({ editsettingModal: true });
                                                                    }
                                                                    }> Edit</a></td>
                                                                </tr>
                                                            </table>
                                                        </div> */}








                                                        <div class="table-responsive">
          {console.log("this.state.cms",this.state.cms && this.state.cms.length > 0,this.state.cms)}
        {this.state.cms && this.state.cms.length > 0 ?
  <table className="table recepients_table">
    <thead>
    <tr>
    <th>APR Month</th>
    <th>Action</th>
    </tr>
    </thead>
    {this.state.poolinfo &&  this.state.poolinfo.length > 0 && this.state.poolinfo?.map((data , i)=><>
      <tr>
      <td>
     
    
        <div className="p-0 table_det">
          <span className="table_text">{getdays(data.lockedPeriod)}</span>
    
      </div>
      </td>
      {/* <td>{data.settingvalue}</td> */}
      <td className="d-flex justify-content-start"><a className="link_text" onClick={() => {
       this.setState({"singlesetting" : data,
          "pid": i})
       
    this.setState({ editaprModal: true });
}
}> Edit</a></td>
      
    </tr>
    </>
    )}
    


    {/* <tr>
      <td>
     
    
        <div className="p-0 table_det">
          <span className="table_text">Lorem Ipsum</span>
    
      </div>
      </td>
      <td>Lorem Ipsum</td>
      <td className="d-flex justify-content-end"><a className="link_text" onClick={() => this.setState({ editsettingModal: true })}>Edit</a></td>
      
    </tr>
    <tr>
      <td>
     
    
        <div className="p-0 table_det">
          <span className="table_text">Lorem Ipsum</span>
    
      </div>
      </td>
      <td>Lorem Ipsum</td>
      <td className="d-flex justify-content-end"><a className="link_text" onClick={() => this.setState({ editsettingModal: true })}>Edit</a></td>
      
    </tr> */}
   
  </table> : <p className='no_data_text'>No Data Found</p>}
</div>

                                                    </div>
                                                </div>


                                                {/* <div className="row mb-3">
                                                    <div className='col-8 col-sm-5 col-md-5 px-1 mb-3'>
                                                        <p className='input_desc_sm'>Banner Image</p>
                                                        <input type="file" className='listedimg' name="myImage" onChange={this.onImageChange} />
                                                    
                                                    </div>

                                                    <div className='col-4 col-sm-5 col-md-4 px-1 mb-3'>
                                                        <img className='img-fluid bannerimgh' src={this.state.image} />
                                                    </div>
                                                </div> */}




                                            </div>
                                        </div>


                                    </div>
                                    {/* end ongoing_sec */}

                                </div>
                            </div>
                        </div>
                    </div>
                    {editaprModal && <Editaprmodal data={this.state.singlesetting}   pid={this.state?.pid} onDismiss={() => this.onDismiss()} getpoolinfodata={() => this.getpoolinfodata()} />}
                    {addsettingModal && <Addsettingmodal onDismiss={() => this.onDismissAdd()} getset={() => this.getsetting()} />}


                    {/* <Footer /> */}
                </div>
            </div >
        )
    }
}

export default Adminaprfee